import { SideBarDef } from 'ag-grid-community';
import { DateRangeTypes } from '../graphql';
import { COMMA, ENTER, SEMICOLON } from '@angular/cdk/keycodes';

export { DateRangeTypes } from '../graphql';

export const BA_MODAL_WIDTH = '500px';
export const INTERNAL_USERNAME_SUFFIX = '@biomedata.io';
export const BIOME_TENANT_ID = 'fce3134bd2da11ed9d2400';
export const CVHS_TENANT_ID = '9C5P6fDrrknAPuv5AKDE2x';
export const MAX_SAVED_IDS = 5;
export const LOCAL_LOGIN_IDS_KEY = 'baLoginIds';
export const MAXIMUM_VARIATIONS = 24;
export const URL_REGEX =
  '^https:\\/\\/(([-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6})|(localhost))\\b([-a-zA-Z0-9()@:%_\\+.~#?&\\/\\/=]*)';
export const TITLES: string[] = ['Dr.', 'Mr.', 'Ms.', 'Mrs.'];
export const columnSideBar: SideBarDef = {
  toolPanels: [
    {
      id: 'columns',
      labelDefault: 'Columns',
      labelKey: 'columns',
      iconKey: 'columns',
      toolPanel: 'agColumnsToolPanel',
      toolPanelParams: {
        suppressRowGroups: true,
        suppressValues: true,
        suppressPivots: true,
        suppressPivotMode: true,
        suppressColumnExpandAll: true,
      },
    },
  ],
  defaultToolPanel: '',
};
export const SROG_PRIORITY_DSMS = ['STS', 'CathPCI', 'TAVR'];
export const DEFAULT_REVIEW_DSMS = ['STS', 'CathPCI', 'TAVR'];
export const FLAG_TYPE_SUPPORTED_DSMS = ['TAVR', 'STS', 'CathPCI'];
export const MONTHS = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
];

export const DATE_RANGE_LABELS = {
  [DateRangeTypes.LastWeek]: 'Last Week',
  [DateRangeTypes.LastMonth]: 'Last Month',
  [DateRangeTypes.LastQuarter]: 'Last Quarter',
  [DateRangeTypes.Last3Months]: 'Last 3 Months',
  [DateRangeTypes.Last4Quarters]: 'Last 4 Quarters',
  [DateRangeTypes.CustomDateRange]: 'Custom Date Range',
  [DateRangeTypes.CustomQuarters]: 'Custom Quarters',
};
export const DATE_RANGE_ORDER = [
  DateRangeTypes.LastWeek,
  DateRangeTypes.LastMonth,
  DateRangeTypes.LastQuarter,
  DateRangeTypes.Last3Months,
  DateRangeTypes.Last4Quarters,
  DateRangeTypes.CustomDateRange,
  DateRangeTypes.CustomQuarters,
];
export const ALL_DSM = { id: 0, code: 'All', name: 'All', datasets: null };
export const MONTH_ORDER: Record<string, number> = {
  january: 0,
  february: 1,
  march: 2,
  april: 3,
  may: 4,
  june: 5,
  july: 6,
  august: 7,
  september: 8,
  october: 9,
  november: 10,
  december: 11,
};
export function sortMonthsChronologically(months: string[]): string[] {
  return [...months].sort((firstMonth, secondMonth) => {
    const firstMonthIndex = MONTH_ORDER[firstMonth.toLowerCase()] ?? Infinity;
    const secondMonthIndex = MONTH_ORDER[secondMonth.toLowerCase()] ?? Infinity;
    return firstMonthIndex - secondMonthIndex;
  });
}
export const separatorKeysCodes: number[] = [ENTER, COMMA, SEMICOLON];
